import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';
import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import { type LifeReadinessResponse } from '@backrs_ui/grow-ui/src/redux/coachingAnalytics';

const { coachingAnalytics } = appStrings.modules;

export const useAgentContext = (data: LifeReadinessResponse, detail = false) => {
  useRegisterAgentContext({
    kind: 'section',
    title: coachingAnalytics.lifeReadiness.title,
    description: coachingAnalytics.lifeReadiness.subtitle,
  });

  useRegisterAgentContext({
    kind: 'visual',
    label: coachingAnalytics.lifeReadiness.completion.title,
    display: 'Pie of the completed/in-progress/not-started split.',
    detail: coachingAnalytics.lifeReadiness.completion.caveat(data.completion.questions.visible),
    data: data.completion,
  });

  useRegisterAgentContext({
    kind: 'visual',
    label: coachingAnalytics.lifeReadiness.byCategory.title,
    display:
      'One stacked bar per readiness category, splitting answers into the self-rated rungs not-yet/early/strong/advanced. The unit is answers, not students.',
    detail: coachingAnalytics.lifeReadiness.byCategory.caveat,
    data: {
      unit: 'answers',
      students_started: data.readiness_by_category.students_started,
      categories: data.readiness_by_category.categories.map((category) => ({
        name: category.name,
        answers: category.answers.total,
        bands: category.answers.bands,
        coverage: category.coverage,
      })),
    },
  });

  useRegisterAgentContext(
    detail
      ? {
          kind: 'visual',
          label: coachingAnalytics.lifeReadiness.byFacet.title,
          display:
            'Category dropdown; one stacked bar per facet (question) in the selected category, splitting students by the rung of their latest self-rating: not-yet/early/strong/advanced. The unit is students, one latest answer each.',
          detail: coachingAnalytics.lifeReadiness.byFacet.caveat,
          data: {
            unit: 'students',
            categories: data.readiness_by_facet.categories.map((category) => ({
              name: category.name,
              description: category.description,
              facets: category.facets.map((facet) => ({
                name: facet.name,
                answered: facet.answers.total,
                bands: facet.answers.bands,
              })),
            })),
          },
        }
      : null,
  );
};
